import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2d443795"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "card card-flush" }
const _hoisted_2 = { class: "px-7 pt-5 pb-1 d-row border-bottom" }
const _hoisted_3 = { class: "card-title d-flex align-items-start flex-column" }
const _hoisted_4 = { class: "card-label fw-bolder" }
const _hoisted_5 = { class: "heatmap-wrap" }
const _hoisted_6 = ["title"]
const _hoisted_7 = { class: "heatmap-legend" }
const _hoisted_8 = /*#__PURE__*/_createStaticVNode("<span class=\"heatmap-cell level-0\" data-v-2d443795></span><span class=\"heatmap-cell level-1\" data-v-2d443795></span><span class=\"heatmap-cell level-2\" data-v-2d443795></span><span class=\"heatmap-cell level-3\" data-v-2d443795></span><span class=\"heatmap-cell level-4\" data-v-2d443795></span>", 5)

import { computed } from "vue";
import moment from "moment";

type TimelineItem = { created_at: string };


export default /*#__PURE__*/_defineComponent({
  props: {
    timeline: null,
    title: null,
    lessActiveLabel: null,
    moreActiveLabel: null
  },
  setup(__props: any) {

const props = __props as {
  timeline: TimelineItem[];
  title: string;
  lessActiveLabel: string;
  moreActiveLabel: string;
}



// Not tied to real weekdays anymore — rows are just a grid shape chosen so
// cells stay large enough to hover comfortably while still fitting a full
// year without any horizontal scrolling.
const ROWS = 15;
const DAYS_TOTAL = 365;
const COLS = Math.ceil(DAYS_TOTAL / ROWS);

const dayColumns = computed(() => {
  const counts = new Map<string, number>();
  (props.timeline || []).forEach((item) => {
    if (!item?.created_at) return;
    const day = moment(item.created_at).format("YYYY-MM-DD");
    counts.set(day, (counts.get(day) || 0) + 1);
  });

  const maxCount = Math.max(1, ...Array.from(counts.values()));

  const intensity = (count: number) => {
    if (count <= 0) return 0;
    const ratio = count / maxCount;
    if (ratio > 0.75) return 4;
    if (ratio > 0.5) return 3;
    if (ratio > 0.25) return 2;
    return 1;
  };

  const today = moment().startOf("day");
  const start = today.clone().subtract(COLS * ROWS - 1, "days");

  const days: { date: string; count: number; level: number; isFuture: boolean }[] = [];
  for (let i = 0; i < COLS * ROWS; i++) {
    const date = start.clone().add(i, "days");
    const key = date.format("YYYY-MM-DD");
    const count = counts.get(key) || 0;
    days.push({ date: key, count, level: intensity(count), isFuture: date.isAfter(today) });
  }

  const columns: { date: string; count: number; level: number; isFuture: boolean }[][] = [];
  for (let c = 0; c < COLS; c++) {
    columns.push(days.slice(c * ROWS, c * ROWS + ROWS));
  }
  return columns;
});

const monthLabels = computed(() => {
  const labels: { colIndex: number; label: string }[] = [];
  let lastMonth: number | null = null;

  dayColumns.value.forEach((column, colIndex) => {
    const firstDay = column[0];
    if (!firstDay) return;
    const month = moment(firstDay.date).month();
    if (month !== lastMonth) {
      labels.push({ colIndex, label: moment(firstDay.date).format("MMM") });
      lastMonth = month;
    }
  });

  return labels;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h4", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, _toDisplayString(__props.title), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("div", {
        class: "heatmap-months",
        style: _normalizeStyle({ gridTemplateColumns: `repeat(${_unref(COLS)}, 1fr)` })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(monthLabels), (month) => {
          return (_openBlock(), _createElementBlock("span", {
            key: `${month.colIndex}-${month.label}`,
            class: "heatmap-month-label",
            style: _normalizeStyle({ gridColumnStart: month.colIndex + 1 })
          }, _toDisplayString(month.label), 5))
        }), 128))
      ], 4),
      _createElementVNode("div", {
        class: "heatmap-grid",
        style: _normalizeStyle({ gridTemplateColumns: `repeat(${_unref(COLS)}, 1fr)` })
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(dayColumns), (column, cIdx) => {
          return (_openBlock(), _createElementBlock("div", {
            key: cIdx,
            class: "heatmap-column"
          }, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(column, (day) => {
              return (_openBlock(), _createElementBlock("div", {
                key: day.date,
                class: _normalizeClass(["heatmap-cell", [`level-${day.level}`, { 'is-future': day.isFuture }]]),
                title: `${day.date}: ${day.count}`
              }, null, 10, _hoisted_6))
            }), 128))
          ]))
        }), 128))
      ], 4)
    ]),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("span", null, _toDisplayString(__props.lessActiveLabel), 1),
      _hoisted_8,
      _createElementVNode("span", null, _toDisplayString(__props.moreActiveLabel), 1)
    ])
  ]))
}
}

})